
import { Interview } from '@/types/interview';

export function useInterviewSelection() {
  // Selects interviews that are ready for auto-publishing
  const getInterviewsToPublish = (interviews: Interview[] | undefined): Interview[] => {
    if (!interviews || interviews.length === 0) {
      return [];
    }
    
    console.log('Filtering interviews for auto-publishing');
    
    // Debug log all interviews for visibility on what's being filtered
    interviews.forEach(interview => {
      console.log(`Checking interview ${interview.id}: Status=${interview.publication_status}, InFeeder=${interview.is_in_feeder}`);
    });
    
    // For feeder page, we want interviews that are both:
    // 1. In the feeder (is_in_feeder === true)
    // 2. Have pending status (publication_status === 'pending')
    const filteredInterviews = interviews.filter(interview => 
      interview.publication_status === 'pending' && 
      interview.is_in_feeder === true
    );
    
    console.log(`Found ${filteredInterviews.length} interviews ready for publishing`);
    return filteredInterviews;
  };
  
  // Gets debug information about feeder interviews
  const getFeederDebugInfo = (interviews: Interview[] | undefined) => {
    if (!interviews) return { anyFeederInterviews: false, pendingCount: 0, feederInterviewStatuses: '', nonPendingCount: 0 };
    
    const anyFeederInterviews = interviews.some(i => i.is_in_feeder === true);
    
    const feederInterviews = interviews.filter(i => i.is_in_feeder === true);
    const pendingCount = feederInterviews.filter(i => i.publication_status === 'pending').length;
    const nonPendingCount = feederInterviews.filter(i => i.publication_status !== 'pending').length;
    
    const feederInterviewStatuses = feederInterviews
      .map(i => `${i.intervieweeName}: ${i.publication_status}`)
      .join(', ');
      
    return {
      anyFeederInterviews,
      pendingCount,
      nonPendingCount,
      feederInterviewStatuses
    };
  };
  
  return {
    getInterviewsToPublish,
    getFeederDebugInfo
  };
}
